


































import { Component, Vue } from 'vue-property-decorator';
import KnowMoreBtn from '@/components/know-more-button/Know-more-btn.vue';
import imgs from '@/util/imgs.ts';

@Component({
  components: {
    KnowMoreBtn,
  },
})
export default class Twoimgs extends Vue {
  private imgs = imgs;
  private gotoMachiningPage(section: number) {
    this.$router.push(`/machining?section=${section}`);
  }
}
